import React from "react";
import Form from "react-bootstrap/Form";

const AuthRow = ({authority, onChange, readEnabled, writeEnabled, id, idx}) =>
	<tr>
  		<td className="ps-3 border-0 p-0">
  			{authority.subAuthority === true ?  <Form.Label id={`${id}Label-${idx}`} className="ms-3">{authority.description}</Form.Label> : <Form.Label id={`${id}Label-${idx}`}>{authority.description}</Form.Label>}
  		</td>
  		<td className="text-center border-0 p-0">
  			{ authority.readEnabled === true && 
				<input
					id={`${id}ReadCheckbox-${idx}`}
		            type="checkbox"
		            value={authority.readMapping}
		            key={authority.readMapping}
		            checked={authority.readGranted}
		            onChange={onChange}
		            disabled={!readEnabled}
		          />
	        }
		</td>
  		<td className="text-center border-0 p-0">
  			{ authority.writeEnabled === true &&
				<input
					id={`${id}WriteCheckbox-${idx}`}
		            type="checkbox"
		            value={authority.writeMapping}
		            key={authority.writeMapping}
		            checked={authority.writeGranted}
		            onChange={onChange}
		            disabled={!writeEnabled}
		          />
	        }
      </td>
  	</tr>
  	;

 export { AuthRow };